import { createStore } from "vuex";
import {ref} from 'vue'
import { ElMessage } from 'element-plus'

export default createStore({
    state:{
        platformApi:'platform-server/',  //平台接口前缀
        superId:'',  //权限管理id
        tenantId:'',  //租户id
        menu_list:[],
        authority:[],
        stationList:[],  //站点列表
        token_base:'Bearer ',
        token:'',
        // token:'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ0ZW5hbnRJZCI6MSwiZXhwIjoxNzMyOTM1MTI2LCJ1c2VybmFtZSI6Imh1ZW4ifQ.EldTBSl39Awrb2mCxIErFstvSwbTKzHxbYhPawDxVkd1mqio5l6l_w1eWSq-QpJuSpf90P5U7WlX2n-aTgAXWA'
        // token:'cb2c90521406a192d7d26146ed36569af44918c12a203ba16428862d0f2dc5ab344c70b586974124f12e51a466e090e0',
        // token:"Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiJ9.eyJ1c2VySW5mbyI6IntcImF1dGhvcml0eVwiOlt7XCJjaGlsZHJlblwiOlt7XCJjaGlsZHJlblwiOltdLFwiaWRcIjozLFwibmFtZVwiOlwi5YWF55S16K6-5aSHXCIsXCJwYXJlbnRJZFwiOjEsXCJzZXFcIjowLFwidHlwZVwiOlwiTUVOVVwifSx7XCJjaGlsZHJlblwiOltdLFwiaWRcIjo0LFwibmFtZVwiOlwi5pm66IO95YyW6K6-5aSHXCIsXCJwYXJlbnRJZFwiOjEsXCJzZXFcIjoxLFwidHlwZVwiOlwiTUVOVVwifV0sXCJpZFwiOjEsXCJuYW1lXCI6XCLorr7lpIfnrqHnkIZcIixcInBhcmVudElkXCI6MCxcInNlcVwiOjAsXCJ0eXBlXCI6XCJNRU5VXCJ9XSxcImlkXCI6MSxcImxvZ2luVGltZVwiOlwiMjAyNC0xMS0yOCAxNjo0NToyMC41NjNcIixcInJlYWxOYW1lXCI6XCLog6HmgalcIixcInJvbGVzXCI6W1wiU1VQRVJcIixcIlVTRVJcIl0sXCJzZWNyZXRLZXlcIjpcIjl6WUlzeWxyV1pNMmJ4UTJaa1QyM242L0lwaFFnVSsxcjRkQ0oxTXdyMGc9XCIsXCJ0ZW5hbnRDb2RlXCI6XCJnenljXCIsXCJ0ZW5hbnRJZFwiOjEsXCJ1c2VybmFtZVwiOlwiaHVlblwifSIsInRlbmFudElkIjoxLCJleHAiOjE3MzI4Njk5MjAsInVzZXJuYW1lIjoiaHVlbiJ9.7g2b0gbobJVca-PojahGyDXUxmIooeZMCEnMXWlHyTvn7tfqjjyHgRxbxxX_n58OnWw5rMsTp79CaJPmDBCIaA "
        // tabs面包屑的数据
        HeaderTabs: localStorage.getItem('HeaderTabs') ? JSON.parse(localStorage.getItem('HeaderTabs')) : [
            {
            topic:"首页",
            path:'/home'
            }
        ],
        TabsActiveName: localStorage.getItem('TabsActiveName') || "/home"
    },
    getters:{},
    mutations:{
        // 修改tabs的索引绑定
        updateTabsActiveName(state,msg){
            // 修改标签索引
            state.TabsActiveName = msg
            localStorage.setItem('TabsActiveName', msg);
        },
        // 添加tabs标签
        addHeaderTabs(state,msg){
            // 用filter过滤器看添加项是否已存在，如果存在则不添加
            let f = state.HeaderTabs.filter(t=>{
            return t.path == msg.path
            })
            if(f.length==0){
                state.HeaderTabs.push(msg)
            }
            state.TabsActiveName = msg.path
            localStorage.setItem('TabsActiveName', msg.path);
            localStorage.setItem('HeaderTabs', JSON.stringify(state.HeaderTabs));
        },
        // 删除tabs标签
        removeHeaderTabs(state,msg){
            // 如果要删除的是首页就直接退出，这里根据业务而定
            if(msg=="/home") return;
            // 通过循环方式找到要删除的数据项
            state.HeaderTabs.forEach((item,index)=>{
            if(item.path==msg){
                state.HeaderTabs.splice(index,1);
                return true;
            }
            })
            // 如果当前显示页如删除项一样，则自动跳转会首页,这里也是根据具体业务而定
            if(state.TabsActiveName==msg){
            // state.TabsActiveName = "/home"
            state.TabsActiveName = state.HeaderTabs[state.HeaderTabs.length - 1].path;
            }
            localStorage.setItem('TabsActiveName', state.TabsActiveName);
            localStorage.setItem('HeaderTabs', JSON.stringify(state.HeaderTabs));
        },
        // 关闭其他标签（保留指定标签和首页），这里必须用splice原地修改，保持HeaderTabs的引用不变
        closeOtherTabs(state,msg){
            const keep = state.HeaderTabs.filter(t=>{
                return t.path == msg || t.path == "/home"
            })
            state.HeaderTabs.splice(0, state.HeaderTabs.length, ...keep);
            // 如果当前激活的标签被关闭了，则切换到指定标签
            if(!keep.some(t=>t.path == state.TabsActiveName)){
                state.TabsActiveName = msg;
            }
            localStorage.setItem('TabsActiveName', state.TabsActiveName);
            localStorage.setItem('HeaderTabs', JSON.stringify(state.HeaderTabs));
        },
        // 关闭指定标签右侧的所有标签（首页始终保留）
        closeRightTabs(state,msg){
            const index = state.HeaderTabs.findIndex(t=>t.path == msg);
            if(index == -1) return;
            const keep = state.HeaderTabs.filter((t,i)=>{
                return i <= index || t.path == "/home"
            })
            state.HeaderTabs.splice(0, state.HeaderTabs.length, ...keep);
            if(!keep.some(t=>t.path == state.TabsActiveName)){
                state.TabsActiveName = msg;
            }
            localStorage.setItem('TabsActiveName', state.TabsActiveName);
            localStorage.setItem('HeaderTabs', JSON.stringify(state.HeaderTabs));
        }
    },
    actions:{}
})